import request from "./request";
//书籍列表
export function getBooksList() {
    return request({
        url: `/portal/book`,
        method: "get",
    });
}

//图形码
export function captchaImg() {
    return request({
        url: `/captcha`,
        method: "get",
    });
}

//图形码
export function sendCode(data) {
    return request({
        url: `/sms/sendCode`,
        method: "post",
        data:data
    });
}

//登录
export function login(data) {
    return request({
        url: `/portal/user/sms-login`,
        method: "post",
        data:data
    });
}

//个人发票查询
export function userInvoice() {
    return request({
        url: `/portal/user/invoice/personal`,
        method: "get",
    });
}

//新增个人发票
export function addUserInvoice(data) {
    return request({
        url: `/portal/user/invoice`,
        method: "post",
        data:data
    });
}

//更新发票
export function putInvoice(data) {
    return request({
        url: `/portal/user/invoice`,
        method: "put",
        data:data
    });
}

//删除发票
export function delInvoice(id) {
    return request({
        url: `/portal/user/invoice/${id}`,
        method: "delete",
    });
}

//申请发票
export function applyInvoice(data) {
    return request({
        url: `/portal/user/order/applyInvoice`,
        method: "post",
        data:data
    });
}

//单位发票查询
export function companyInvoice() {
    return request({
        url: `/portal/user/invoice/company`,
        method: "get",
    });
}

//收货地址查询
export function receivingAddress() {
    return request({
        url: `/portal/user/address`,
        method: "get",
    });
}

//获取省份
export function getProvince() {
    return request({
        url: `/portal/address/province`,
        method: "get",
    });
}

//获取城市
export function getCity(provinceCode) {
    console.log(provinceCode)
    return request({
        url: `/portal/address/city?provinceCode=${provinceCode}`,
        method: "get",
    });
}

//获取区域
export function getArea(provinceCode,cityCode) {
    return request({
        url: `/portal/address/area?provinceCode=${provinceCode}&cityCode=${cityCode}`,
        method: "get",
    });
}

//添加地址
export function address(data) {
    return request({
        url: `/portal/user/address`,
        method: "post",
        data:data
    });
}

//删除地址
export function delAddress(id) {
    return request({
        url: `/portal/user/address/${id}`,
        method: "delete",
    });
}

//更新收货地址
export function putAddress(params) {
    return request({
        url: `/portal/user/address`,
        method: "put",
        data:params
    });
}


//添加订单
export function addOrder(data) {
    return request({
        url: `/portal/user/order`,
        method: "post",
        data:data
    });
}


//取消订单
export function cancelOrder(id) {
    return request({
        url: `/portal/user/order/cancel/${id}`,
        method: "post"
    });
}

//获取订单信息
export function getOrder(orderId) {
    return request({
        url: `/portal/user/order/${orderId}`,
        method: "get",
    });
}

//上传订单凭证
export function uploadEvidence(data) {
    return request({
        url: `/portal/user/order/uploadEvidence`,
        method: "post",
        data:data
    });
}

//凭证绑定订单
export function payEvidence(data) {
    return request({
        url: `/portal/user/order/payEvidence`,
        method: "post",
        data:data
    });
}

//获取个人信息
export function userInfo() {
    return request({
        url: `/portal/user/info`,
        method: "get",
    });
}

//获取订单列表
export function getOrderList(page) {
    console.log(page)
    return request({
        url: `/portal/user/order/list?pageNo=${page.pageNum}&row=${page.pageSize}`,
        method: "get",
    });
}

//获取订单详情
export function getOrderDetail(orderId) {
    return request({
        url: `/portal/user/order/${orderId}`,
        method: "get",
    });
}

//查询支付凭证
export function evidenceList(orderId){
    return request({
        url: `/portal/user/order/evidenceList/${orderId}`,
        method: "get",
    });
}

//删除凭证
export function delEvidence(id) {
    return request({
        url: `/portal/user/order/evidence/${id}`,
        method: "delete",
    });
}

//删除订单
export function delOrder(id) {
    return request({
        url: `/portal/user/order/${id}`,
        method: "delete",
    });
}


//支付宝支付
export function Alipay(id) {
    return request({
        url: `/portal/alipay/web/create-order/${id}`,
        method: "post",
    });
}

//查询订单状态
export function getOrderStatus(id) {
    return request({
        url: `/portal/user/order/getOrderStatus/${id}`,
        method: "get",
    });
}

//微信支付
export function wxpay(id) {
    return request({
        url: `/portal/wxpay/generate-qrcode/${id}`,
        method: "get",
    });
}

//查询当前地址是否可配送
export function searchPortal(data) {
    return request({
        url: `/portal/yto/in-search`,
        method: "post",
        data:data
    });
}


//查询订单轨迹
export function queryTrack(data) {
    return request({
        url: `/portal/yto/query-track`,
        method: "post",
        data:data
    });
}





